import { useLocation, useNavigate } from "react-router-dom";

export const useHandleNavClickCommunityPage = () => {

    const location = useLocation();
    const navigate = useNavigate();

    return (link) => {
        const scrollTargets = {
            "/#aboutUs": "aboutUs",
            "/#hireUs": "hireUs",
            "/#members": "members",
            "/our_community#projects": "projects",  // Add this line
        };

        const sectionId = scrollTargets[link];
        if (sectionId) {
            if (location.pathname === "/our_community") {
                const section = document.getElementById(sectionId);
                section?.scrollIntoView({ behavior: "smooth" });
            } else {
                navigate("/our_community", { state: { scrollTo: sectionId } });
            }
        } else {
            navigate(link);
        }
    };
};


export const useHandleNavClickHomePage = () => {

    const location = useLocation();
    const navigate = useNavigate();

    return (link) => {
        const scrollTargets = {
            "/#tech-hangout": "tech-hangout",
            "/#sponsors": "sponsors",
        };

        if (scrollTargets[link]) {
            const sectionId = scrollTargets[link];
            if (location.pathname === "/") {
                const section = document.getElementById(sectionId);
                section?.scrollIntoView({ behavior: "smooth" });
            } else {
                navigate("/", { state: { scrollTo: sectionId } });
            }
        } else {
            navigate(link);
        }
    };
};